import {
  DELETE_PROJECTS_CATALOG,
  DELETE_PROJECTS_CATALOG_SUCCESS,
  DELETE_PROJECTS_CATALOG_ERROR,
} from '../../../../constants/constantsRed';

export const deleteProjectsCatalogRed = (state: any = false, actions: any) => {
  switch (actions.type) {
    case DELETE_PROJECTS_CATALOG:
      return {
        ...state,
        loading: true,
      };
    case DELETE_PROJECTS_CATALOG_SUCCESS:
      return {
        data: null,
        loading: false,
        error: null,
      };
    case DELETE_PROJECTS_CATALOG_ERROR:
      return {
        ...state,
        loading: false,
        error: null,
        data: actions.payload,
      };
    default:
      return state;
  }
};
